// extracted by mini-css-extract-plugin
module.exports = {"formatted_number":"FormatterNumber_formatted_number__Uc1Q_"};